import Config from './config.json';

const loginValidation = {
    userName: {
        required: Config.default_Required_Message,
    },
    passWord: {
        required: Config.default_Required_Message,
        incorrect: 'Email or password incorrect',
        regex: '(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{9,16}',
    },
};

export default loginValidation;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/validation/customMessages/login.ts